import { render, staticRenderFns } from "./OrgRecord.vue?vue&type=template&id=5af0d308&scoped=true&"
import script from "./OrgRecord.vue?vue&type=script&lang=js&"
export * from "./OrgRecord.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./OrgRecord.vue?vue&type=style&index=0&id=5af0d308&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5af0d308",
  "44f498f5"
  
)

export default component.exports